const ChevronBack = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g id='Chevrons'>
                <path
                    id='Union'
                    d='M14.7549 2.39774C15.2685 1.86742 16.1012 1.86742 16.6148 2.39774C17.1284 2.92806 17.1284 3.78787 16.6148 4.31819L9.17509 12L16.6148 19.6818C17.1284 20.2121 17.1284 21.0719 16.6148 21.6023C16.1012 22.1326 15.2685 22.1326 14.7549 21.6023L6.3852 12.9602C5.8716 12.4299 5.8716 11.5701 6.3852 11.0398'
                    fill='#3A4146'
                />
            </g>
        </svg>
    );
};

export default ChevronBack;
